<div class="menu-options">
  @for (item of items(); track $index) {
    @if (item.divider) {
      <hr class="divider" />
    } @else {
      <button
        type="button"
        class="button-reset menu-option"
        data-testid="context-menu-item"
        [attr.data-test-value]="item.label"
        [tabindex]="$index"
        (click)="itemClicked.emit(item.clickValue)"
        (keydown)="onItemKeyDown($event, item.clickValue)">
        @if (item.icon) {
          <orbit-fa-icon
            [iconSize]="item.iconSize"
            [class]="item.iconClass"
            [iconName]="item.icon" />
        }
        @if (item.label) {
          <div class="label">{{ item.label | translate }}</div>
        }
      </button>
    }
  }
</div>
<orbit-fa-icon class="bubbleArrow" [iconName]="bubbleArrow" />
